<template>
  <span class="estimate-item-comment-icons">
    <template v-if="!useReportToggle">
    <template v-if="isAdjReport || isOnReportRepairer">

    </template>
    <template v-else>
      <i
        v-if="!isDeleted && isHasEstimateComment"
        @click="emitToggleComment"
        class="bx bx-note"
        v-b-tooltip.hover="{ customClass: 'ps-tooltip estimate-comment-tooltip adj-status-tooltip', html: true, title: estimateCommentTitle, placement: 'bottomleft' }"
        style="color: #02C39A; cursor: pointer; z-index: 99;"
      ></i>
      <i
        v-if="!isDeleted && isHasComment"
        @click="emitToggleComment"
        class="bx bx-note"
        v-b-tooltip.hover="{ customClass: 'ps-tooltip internal-comment-tooltip adj-status-tooltip', html: true, title: internalCommentTitle, placement: 'bottomleft' }"
        style="color: #FE914A; cursor: pointer; z-index: 99;"
      ></i>
    </template>
    <i
      v-if="!isDeleted && isHasPartssearchComment"
      @click="emitToggleComment"
      class="bx bx-note"
      style="color: #29BBC1; cursor: pointer; z-index: 99;"
    ></i>
    <i
      v-if="!isDeleted && isHasPartssearchLinkedPart"
      v-b-tooltip.hover.topleft
      :title="'Linked to: ' + partssearchLinkedPartName"
      class="bx bx-link-alt"
      style="color: #a0a0a0; cursor: pointer; z-index: 99;"
    ></i>
    </template>
    <template v-else>

    <template>
      <i
        v-if="!isDeleted && isHasEstimateComment"
        @click="emitToggleComment"
        class="bx bx-note"
        v-b-tooltip.hover="{ customClass: 'ps-tooltip estimate-comment-tooltip adj-status-tooltip', html: true, title: estimateCommentTitle, placement: 'bottomleft' }"
        style="color: #02C39A; cursor: pointer; z-index: 99;"
      ></i>
      <i
        v-if="!isDeleted && isHasComment"
        @click="emitToggleComment"
        class="bx bx-note"
        v-b-tooltip.hover="{ customClass: 'ps-tooltip internal-comment-tooltip adj-status-tooltip', html: true, title: internalCommentTitle, placement: 'bottomleft' }"
        style="color: #FE914A; cursor: pointer; z-index: 99;"
      ></i>
    </template>
    <i
      v-if="!isDeleted && isHasPartssearchComment"
      @click="emitToggleComment"
      class="bx bx-note"
      style="color: #29BBC1; cursor: pointer; z-index: 99;"
    ></i>
    </template>
<i v-if="!isAuthorized"
    @click="emitClickReport"
    class="bx bx-note bx-letter-r adj"
    :class="{ active: !isDeleted && (isAdjReport || isOnReportRepairer) }"
    v-b-tooltip.hover="{ customClass: 'ps-tooltip internal-comment-tooltip adj-status-tooltip', html: true, title: reportTooltipTitle, placement: 'bottomleft' }"
    :style="{ color: isDeleted ? '#ADADAD' : '#FE914A', cursor: isDeleted ? 'default' : 'pointer', zIndex: 99 }"
></i>
<i v-else
   @click="emitClickReport"
   class="bx bx-note bx-letter-r adj auth"
   :class="{ active: !isDeleted && (isAdjReport || isOnReportRepairer) }"
   :style="isDeleted ? 'color: #ADADAD; cursor: default; z-index: 99;' : (extendedView && (isAdjReport || isOnReportRepairer) ? 'color: #FE914A; cursor: pointer; z-index: 99;' : 'color: #FE914A; cursor: default; z-index: 99;')"
></i>
  </span>
</template>

<script>
export default {
  name: 'estimate-item-comment-icons',
  props: {
    extendedView: {
      type: Boolean,
      default: false,
    },
    isAuthorized:{
      type: Boolean,
      default: false,
    },
    useReportToggle: {
      type: Boolean,
      default: false,
    },
    isAdjReport: {
      type: Boolean,
      required: true,
    },
    isOnReportRepairer: {
      type: Boolean,
      default: false,
    },
    onReportOff: {
      type: Boolean,
      default: false,
    },
    isDeleted: {
      type: Boolean,
      default: false,
    },
    isHasEstimateComment: {
      type: Boolean,
      required: true,
    },
    isHasComment: {
      type: Boolean,
      required: true,
    },
    isHasPartssearchComment: {
      type: Boolean,
      required: true,
    },
    isHasPartssearchLinkedPart: {
      type: Boolean,
      required: true,
    },
    partssearchLinkedPartName: {
      type: String,
      default: '',
    },
    internalCommentTitle: {
      type: String,
      default: '',
    },
    estimateCommentTitle: {
      type: String,
      default: '',
    },

  },
  computed: {
    reportTooltipTitle () {
      if (!this.isAdjReport && !this.isOnReportRepairer && !this.isAuthorized) {
        return 'Set to On Report'
      }
      return ''
    },
  },
  methods: {
    emitToggleComment () {
      this.$emit('toggle-comment')
    },
    emitClickReport () {
      if (this.isDeleted) return
      if (this.isAuthorized && !(this.extendedView && (this.isOnReportRepairer || this.isAdjReport))) return
      this.$emit('click-report', (this.isOnReportRepairer || this.isAdjReport) ? 'remove' : 'add')
    },
  },
}
</script>

<style scoped>
.adj-status-tooltip >>> .tooltip-inner{
  position: relative;
  right: 55px;
  top: 3px;
}
.V3 .estimates-edit .estimate-item-comment-icons{
  display: flex !important;
  align-items: center;
}
.V3 .estimates-edit .estimate-item-comment-icons .bx-letter-r,
.V3 .estimates-edit .item-grey .estimate-item-comment-icons .bx-letter-r{
  margin-top: 0;
  background-color:  #ADADAD !important;
  color: #ADADAD !important;
  -webkit-mask: url('../../assets/img/bx-letter-r.svg') no-repeat center;
  mask: url('../../assets/img/bx-letter-r.svg') no-repeat center;
  -webkit-mask-size: contain;
  mask-size: contain;
}
.V3 .estimates-edit .estimate-item-comment-icons .bx-letter-r:hover,
.V3 .estimates-edit .item-grey .estimate-item-comment-icons .bx-letter-r:hover,
.V3 .estimates-edit .estimate-item-comment-icons .bx-letter-r.active,
.V3 .estimates-edit .item-grey .estimate-item-comment-icons .bx-letter-r.active {
  background-color: #FE914A !important;
  color: #FE914A !important;
}
.V3 .estimates-edit .estimate-item-comment-icons .bx-letter-r.auth:not(.active):hover {
  background-color: #ADADAD !important;
  color: #ADADAD !important;
}

</style>
